import {
  AppBar,
  Toolbar,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Collapse,
} from '@mui/material';
import { AssignmentInd, ExpandLess, ExpandMore, Psychology, Summarize } from '@mui/icons-material';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import MenuIcon from '@mui/icons-material/Menu';
import PeopleIcon from '@mui/icons-material/People';
import EditIcon from '@mui/icons-material/Edit';
import RequestIcon from '@mui/icons-material/RequestPage';
import PolicyIcon from '@mui/icons-material/Policy';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLogin } from 'Contexts/AuthProvider/AuthProvider';
import { useEnrollForm } from 'Contexts/EnrollProvider/EnrollProvider';

export const Header = () => {
  const { user, logout } = useLogin();
  const { setStateDwolla } = useEnrollForm();
  const navigate = useNavigate();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [openSubmenus, setOpenSubmenus] = useState<Record<string, boolean>>({});

  // Manejo del Logout
  const logoutHandle = () => {
    setStateDwolla(0);
    setIsDrawerOpen(false);
    logout();
    navigate('/', { replace: true });
  };

  // Configuración del menú con submenús
  interface MenuItem {
    label: string;
    path?: string;
    roles: string[];
    icon: JSX.Element;
    submenu?: { label: string; path: string; icon: JSX.Element }[];
  }

  const menuItems: MenuItem[] = [
    {
      label: 'Users',
      path: '/backoffice/users',
      roles: ['9'],
      icon: <PeopleIcon />,
    },
    {
      label: 'Website Editor',
      path: '/backoffice/backoffice-editor',
      roles: ['9'],
      icon: <EditIcon />,
    },
    {
      label: 'Request',
      path: '/backoffice',
      roles: ['9'],
      icon: <RequestIcon />,
    },
    {
      label: 'Policies',
      path: '/backoffice/privacy-policy',
      roles: ['9'],
      icon: <PolicyIcon />,
    },
    {
      label: 'Subscriptions',
      roles: ['9'],
      icon: <SubscriptionsIcon />,
      submenu: [
        {
          label: 'Subscriptions Management',
          path: '/subscriptions-management',
          icon: <SubscriptionsIcon />,
        },
        {
          label: 'Subscriptions Submerchant',
          path: '/subscriptions-submerchant',
          icon: <SubscriptionsIcon />,
        },
      ],
    },
    {
      label: 'Reports System',
      path: '/backoffice/privacy-policy',
      roles: ['9'],
      icon: <Summarize />,
    },
    {
      label: 'Directory',
      path: '/backoffice/directory',
      roles: ['9'],
      icon: <AssignmentInd />,
    },
    {
      label: 'SEO Settings',
      path: '/backoffice/seo-settings',
      roles: ['9'],
      icon: <Psychology />,
    },
  ];

  const roleId = localStorage.getItem('role_id');
  const filteredMenuItems = menuItems.filter(
    (item) => !item.roles.length || (roleId && item.roles.includes(roleId))
  );

  // Alternar submenús
  const toggleSubmenu = (label: string) => {
    setOpenSubmenus((prev) => ({ ...prev, [label]: !prev[label] }));
  };

  const handleNavigate = (path: string) => {
    navigate(path, { replace: true });
    setIsDrawerOpen(false);
  };

  return (
    <>
      {/* Header Principal */}
      <AppBar position='static'>
        <Toolbar className='flex justify-between bg-[#fff]'>
          {/* Logo */}
          <IconButton edge='start' onClick={() => navigate('/')} color='inherit'>
            <img
              src='https://noahsark-donate-dev.s3.us-east-1.amazonaws.com/landing/Logo-Noahs-Ark-Market.png'
              alt='Logo'
              style={{ width: 100, height: 'auto' }}
            />
          </IconButton>

          {/* Botón Menú Móvil */}
          {user?.token && (
            <IconButton className='md:hidden' onClick={() => setIsDrawerOpen(true)} color='primary'>
              <MenuIcon />
            </IconButton>
          )}
        </Toolbar>
      </AppBar>

      {/* Menú Lateral para Móvil */}
      <Drawer
        anchor='left'
        open={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        classes={{ paper: 'bg-[#111827] text-white' }}
      >
        <List className='w-64'>
          {/* Logo en el Menú */}
          <div className='flex justify-center p-4'>
            <img
              src='https://noahsark-donate-dev.s3.us-east-1.amazonaws.com/landing/Logo-Noahs-Ark-Market.png'
              alt='Logo'
              style={{ width: 100, height: 'auto' }}
            />
          </div>

          {/* Elementos del Menú */}
          {filteredMenuItems.map((item) => (
            <div key={item.label}>
              <ListItem
                button
                onClick={() =>
                  item.submenu ? toggleSubmenu(item.label) : item.path && handleNavigate(item.path)
                }
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.label} />
                {item.submenu && (openSubmenus[item.label] ? <ExpandLess /> : <ExpandMore />)}
              </ListItem>
              {item.submenu && (
                <Collapse in={openSubmenus[item.label]} timeout='auto' unmountOnExit>
                  <List component='div' disablePadding>
                    {item.submenu.map((sub) => (
                      <ListItem
                        key={sub.label}
                        button
                        onClick={() => handleNavigate(sub.path)}
                        style={{ paddingLeft: 32 }}
                      >
                        <ListItemIcon>{sub.icon}</ListItemIcon>
                        <ListItemText primary={sub.label} />
                      </ListItem>
                    ))}
                  </List>
                </Collapse>
              )}
            </div>
          ))}

          {/* Botón de Logout */}
          <ListItem button onClick={logoutHandle}>
            <ListItemIcon>
              <ExitToAppIcon />
            </ListItemIcon>
            <ListItemText primary='Logout' />
          </ListItem>
        </List>
      </Drawer>
    </>
  );
};
